import {
    USER_SENDING_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_HAVE_PASSWORD_SUCCESS,
    USER_REQUEST_FAIL,
    USER_LOGOUT,
} from "../action-types/user"

const userInitLocalStorage = JSON.parse(window.localStorage.getItem("userInfo userReducer"))
const userInit = {
    loading: false,
    message: "",
    user: !userInitLocalStorage ? "" : userInitLocalStorage,
    token: "",
    successStatus: false,
    passwordChange: false,
}
export default function userReducer(state = userInit, action) {
    switch (action.type) {
        case USER_SENDING_REQUEST: {
            return {
                ...state,
                loading: true,
                successStatus: false,
            }
        }
        case USER_LOGIN_SUCCESS: {
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                user: action.payload.user,
                token: action.payload.token,
                successStatus: true,
            }
        }
        case USER_UPDATE_SUCCESS: {
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                user: action.payload.user,
                token: action.payload.token ? action.payload.token : state.token,
                successStatus: true,
            }
        }
        case USER_UPDATE_HAVE_PASSWORD_SUCCESS: {
            return {
                ...state,
                loading: false,
                message: "",
                user: "",
                token: "",
                successStatus: true,
                passwordChange: true,
            }
        }
        case USER_REQUEST_FAIL: {
            return {
                ...state,
                loading: false,
                message: action.payload,
                successStatus: false,
            }
        }
        case USER_LOGOUT: {
            return {
                loading: false,
                message: "",
                user: "",
                token: "",
                successStatus: true,
                passwordChange: false,
            }
        }
        default:
            return state
    }
}
